export const TailgateEnabled = ({
  strokeColor = 'currentColor',
  width = 16,
  height = 16,
  ...props
}: {
  strokeColor?: string
  width?: number | string
  height?: number | string
}) => (
  <svg
    fill='none'
    height={height}
    viewBox='0 0 16 16'
    width={width}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.64428 5.09633L10.1922 7.64428L7.64428 10.1922M10.1922 7.64428H5.09633M14.0141 7.64428C14.0141 11.1623 11.1623 14.0141 7.64428 14.0141C4.1263 14.0141 1.27441 11.1623 1.27441 7.64428C1.27441 4.1263 4.1263 1.27441 7.64428 1.27441C11.1623 1.27441 14.0141 4.1263 14.0141 7.64428Z'
      stroke={strokeColor}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.27397'
    />
  </svg>
)
